module.exports = __webpack_public_path__ + "img/LN.a9dfc9e2.png";